import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { format, parseISO, formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import PropTypes from 'prop-types';

import api from '@/apiRequest';
import { useUser } from '@/contexts/UserContext';

import ActivityLogComponent from './ActivityLogComponent';

const ActivityLogContainer = ({ orderId }) => {
  const [log, setLog] = useState([]);
  const intl = useIntl();
  const user = useUser();

  const toDate = value => (typeof value === 'string' ? parseISO(value) : value);

  useEffect(() => {
    let isMounted = true; // Flag to track if the component is still mounted

    const fetchLog = async () => {
      try {
        var { data } = await api.get(`activity-log/orders/${orderId}/actions`);

        if (!isMounted) return;

        setLog(
          data.map(d => {
            const date = toDate(d.created_at.date);

            return {
              ...d,
              humanDate: formatDistanceToNow(date, { addSuffix: true, locale: ptBR }),
              date: format(date, "dd/MM/yyyy 'às' HH:mm"),
            };
          })
        );
      } catch (err) {
        console.log(err);
      }
    };

    fetchLog();
    return () => {
      isMounted = false;
    };
  }, [orderId, user?.authRole]);

  return log.length > 0 ? <ActivityLogComponent intl={intl} historic={log} /> : null;
};

ActivityLogContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
};

export default ActivityLogContainer;
